import { hasSai } from '../../../Components/Organization/organizationUtils';
import { useCurrentProvider } from '../../../Components/Permissions';
import { Flag } from '../../../featureFlags';
import { Permission } from '../../../graphQL';

export const useShowBeaconNavItem = () => {
  const { currentProvider, hasPermission, featureFlags } = useCurrentProvider();
  const organization = currentProvider.organizations[0];
  return (
    hasPermission(Permission.SaiDataView) &&
    featureFlags.includes(Flag.SaiDashboardsEnabled) &&
    !!organization &&
    hasSai(organization)
  );
};
